import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaHome, FaTree, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import './styles.css';

const Mapa3D = ({ show, onHide, empreendimentoNome, mapa3d, areasLazer }) => {
  const [modo, setModo] = useState('lote');
  const [quadraSelecionada, setQuadraSelecionada] = useState('');
  const [loteSelecionado, setLoteSelecionado] = useState('');
  const [areaLazerSelecionada, setAreaLazerSelecionada] = useState('');
  const [urlAtual, setUrlAtual] = useState('');
  const [quadras, setQuadras] = useState([]);
  const [lotes, setLotes] = useState([]);

  useEffect(() => {
    if (show && mapa3d && mapa3d.length > 0) {
      var quadrasUnicas = [];
      var quadrasMap = {};

      for (var i = 0; i < mapa3d.length; i++) {
        var item = mapa3d[i];
        if (item.mapa1 && !quadrasMap[item.mapa1]) {
          quadrasMap[item.mapa1] = true;
          quadrasUnicas.push(item.mapa1);
        }
      }

      quadrasUnicas.sort();
      setQuadras(quadrasUnicas);
    }
  }, [show, mapa3d]);

  useEffect(() => {
    if (quadraSelecionada && mapa3d && mapa3d.length > 0) {
      var lotesFiltrados = [];
      var lotesMap = {};

      for (var i = 0; i < mapa3d.length; i++) {
        var item = mapa3d[i];
        if (
          item.mapa1 === quadraSelecionada &&
          item.mapa2 &&
          !lotesMap[item.mapa2]
        ) {
          lotesMap[item.mapa2] = true;
          lotesFiltrados.push(item.mapa2);
        }
      }

      lotesFiltrados.sort(function(a, b) {
        var numA = parseInt(a, 10);
        var numB = parseInt(b, 10);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return a.localeCompare(b);
      });

      setLotes(lotesFiltrados);
      setLoteSelecionado('');
      setUrlAtual('');
    } else {
      setLotes([]);
      setLoteSelecionado('');
      setUrlAtual('');
    }
  }, [quadraSelecionada, mapa3d]);

  useEffect(() => {
    if (quadraSelecionada && loteSelecionado && mapa3d && mapa3d.length > 0) {
      for (var i = 0; i < mapa3d.length; i++) {
        var item = mapa3d[i];
        if (
          item.mapa1 === quadraSelecionada &&
          item.mapa2 === loteSelecionado
        ) {
          setUrlAtual(item.url3d || '');
          break;
        }
      }
    } else {
      setUrlAtual('');
    }
  }, [quadraSelecionada, loteSelecionado, mapa3d]);

  useEffect(() => {
    if (areaLazerSelecionada && areasLazer && areasLazer.length > 0) {
      for (var i = 0; i < areasLazer.length; i++) {
        var item = areasLazer[i];
        if (item.descricao === areaLazerSelecionada) {
          setUrlAtual(item.url3d || '');
          break;
        }
      }
    } else if (modo === 'lazer') {
      setUrlAtual('');
    }
  }, [areaLazerSelecionada, areasLazer, modo]);

  const handleModoChange = function(novoModo) {
    setModo(novoModo);
    setQuadraSelecionada('');
    setLoteSelecionado('');
    setAreaLazerSelecionada('');
    setUrlAtual('');
    setLotes([]);
  };

  const handleCopiarUrl = function() {
    if (urlAtual) {
      navigator.clipboard
        .writeText(urlAtual)
        .then(function() {
          toast.success('Link copiado!');
        })
        .catch(function() {
          toast.error('Erro ao copiar link');
        });
    }
  };

  const handleAbrirNovaGuia = function() {
    if (urlAtual) {
      window.open(urlAtual, '_blank');
    }
  };

  const handleClose = function() {
    setModo('lote');
    setQuadraSelecionada('');
    setLoteSelecionado('');
    setAreaLazerSelecionada('');
    setUrlAtual('');
    setLotes([]);
    onHide();
  };

  var temAreasLazer = areasLazer && areasLazer.length > 0;
  var temMapa3d = mapa3d && mapa3d.length > 0;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      centered
      dialogClassName="sismac_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ color: '#fff' }}>
          Lote 3D
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="justify-content-center mb-4">
          <Col xs="auto">
            <Button
              variant={modo === 'lote' ? 'primary' : 'outline-primary'}
              className="mr-2"
              onClick={function() {
                handleModoChange('lote');
              }}
            >
              <FaHome className="mr-1" />
              Lote
            </Button>
            {temAreasLazer && (
              <Button
                variant={modo === 'lazer' ? 'success' : 'outline-success'}
                onClick={function() {
                  handleModoChange('lazer');
                }}
              >
                <FaTree className="mr-1" />
                Lazer
              </Button>
            )}
          </Col>
        </Row>

        {modo === 'lote' && (
          <>
            {!temMapa3d ? (
              <div className="sismac_empty sismac_empty--card">
                <p className="sismac_empty-text">
                  Nenhum lote 3D disponível para este empreendimento.
                </p>
              </div>
            ) : (
              <>
                <Row className="mb-4">
                  <Col xs={12} md={6} className="mb-3 mb-md-0">
                    <Form.Group>
                      <Form.Label className="font-weight-bold">
                        Quadra
                      </Form.Label>
                      <Form.Control
                        as="select"
                        value={quadraSelecionada}
                        onChange={function(e) {
                          setQuadraSelecionada(e.target.value);
                        }}
                      >
                        <option value="">Selecione...</option>
                        {quadras.map(function(quadra, index) {
                          return (
                            <option key={index} value={quadra}>
                              {quadra}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Group>
                      <Form.Label className="font-weight-bold">Lote</Form.Label>
                      <Form.Control
                        as="select"
                        value={loteSelecionado}
                        onChange={function(e) {
                          setLoteSelecionado(e.target.value);
                        }}
                        disabled={!quadraSelecionada}
                      >
                        <option value="">
                          {quadraSelecionada
                            ? 'Selecione...'
                            : 'Selecione Uma Quadra'}
                        </option>
                        {lotes.map(function(lote, index) {
                          return (
                            <option key={index} value={lote}>
                              {lote}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>

                {urlAtual && (
                  <>
                    <Row className="mb-3">
                      <Col xs={12}>
                        <Form.Group className="d-flex">
                          <Form.Control
                            type="text"
                            value={urlAtual}
                            readOnly
                            style={{
                              borderTopLeftRadius: 4,
                              borderBottomLeftRadius: 4,
                              borderTopRightRadius: 0,
                              borderBottomRightRadius: 0,
                            }}
                          />
                          <Button
                            variant="primary"
                            style={{ borderRadius: 0 }}
                            onClick={handleCopiarUrl}
                            title="Copiar link"
                          >
                            <FaCopy />
                          </Button>
                          <Button
                            variant="secondary"
                            style={{
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderTopRightRadius: 4,
                              borderBottomRightRadius: 4,
                            }}
                            onClick={handleAbrirNovaGuia}
                            title="Abrir em nova guia"
                          >
                            <FaExternalLinkAlt />
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Card className="sismac_card">
                      <Card.Body className="p-0">
                        <iframe
                          src={urlAtual}
                          title="Visualização 3D do Lote"
                          style={{
                            width: '100%',
                            height: '500px',
                            border: 'none',
                            borderRadius: '4px',
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </>
                )}
              </>
            )}
          </>
        )}

        {modo === 'lazer' && (
          <>
            {!temAreasLazer ? (
              <div className="sismac_empty sismac_empty--card">
                <p className="sismac_empty-text">
                  Nenhuma área de lazer disponível para este empreendimento.
                </p>
              </div>
            ) : (
              <>
                <Row className="mb-4">
                  <Col xs={12} md={6} className="mx-auto">
                    <Form.Group>
                      <Form.Label className="font-weight-bold">
                        Área Lazer
                      </Form.Label>
                      <Form.Control
                        as="select"
                        value={areaLazerSelecionada}
                        onChange={function(e) {
                          setAreaLazerSelecionada(e.target.value);
                        }}
                      >
                        <option value="">Selecione...</option>
                        {areasLazer.map(function(area, index) {
                          return (
                            <option key={index} value={area.descricao}>
                              {area.descricao}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>

                {urlAtual && (
                  <>
                    <Row className="mb-3">
                      <Col xs={12}>
                        <Form.Group className="d-flex">
                          <Form.Control
                            type="text"
                            value={urlAtual}
                            readOnly
                            style={{
                              borderTopLeftRadius: 4,
                              borderBottomLeftRadius: 4,
                              borderTopRightRadius: 0,
                              borderBottomRightRadius: 0,
                            }}
                          />
                          <Button
                            variant="primary"
                            style={{ borderRadius: 0 }}
                            onClick={handleCopiarUrl}
                            title="Copiar link"
                          >
                            <FaCopy />
                          </Button>
                          <Button
                            variant="secondary"
                            style={{
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderTopRightRadius: 4,
                              borderBottomRightRadius: 4,
                            }}
                            onClick={handleAbrirNovaGuia}
                            title="Abrir em nova guia"
                          >
                            <FaExternalLinkAlt />
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Card className="sismac_card">
                      <Card.Body className="p-0">
                        <iframe
                          src={urlAtual}
                          title="Visualização 3D da Área de Lazer"
                          style={{
                            width: '100%',
                            height: '500px',
                            border: 'none',
                            borderRadius: '4px',
                          }}
                        />
                      </Card.Body>
                    </Card>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Mapa3D;
